import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { getReleases } from "../lib/api";
import { Reveal } from "../components/Motion";

const GROUPS = ["Album", "EP", "Single"];

function ReleaseRow({ release, index }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/music/${release.slug}`)}
      data-testid={`release-row-${release.slug}`}
      className="group w-full grid grid-cols-1 md:grid-cols-12 gap-6 items-center py-8 border-t border-white/10 text-left hover:bg-white/[0.02] transition-colors px-2"
    >
      <div className="hidden md:block md:col-span-1 font-serif text-4xl text-white/20 group-hover:text-gold transition-colors">
        {String(index + 1).padStart(2, "0")}
      </div>
      <div className="md:col-span-2 overflow-hidden aspect-square max-w-[120px]">
        <motion.img
          src={release.artwork}
          alt={release.title}
          className="w-full h-full object-cover"
          whileHover={{ scale: 1.08 }}
          transition={{ duration: 0.8 }}
        />
      </div>
      <div className="md:col-span-6">
        <h3 className="font-serif text-3xl md:text-4xl font-light text-white group-hover:text-gold transition-colors leading-tight">
          {release.title}
        </h3>
        <p className="text-white/50 text-sm mt-2 max-w-md">{release.description}</p>
      </div>
      <div className="md:col-span-2 font-mono text-[11px] tracking-[0.2em] text-white/40">
        {release.year} · {release.trackList.length} TRACKS
      </div>
      <div className="md:col-span-1 font-mono text-[11px] tracking-[0.2em] text-gold text-right opacity-0 group-hover:opacity-100 transition-opacity">
        →
      </div>
    </button>
  );
}

export default function Music() {
  const [releases, setReleases] = useState([]);

  useEffect(() => {
    document.title = "Music — Motion & Meaning";
    getReleases().then(setReleases).catch(() => {});
  }, []);

  return (
    <div className="pt-32 md:pt-44 pb-32" data-testid="music-page">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.4em] text-gold mb-6">THE CATALOG</p>
          <h1 className="font-serif text-6xl sm:text-7xl lg:text-9xl font-light leading-none text-white">MUSIC</h1>
        </Reveal>

        <div className="mt-24 space-y-24">
          {GROUPS.map((group) => {
            const items = releases.filter((r) => r.releaseType === group);
            if (items.length === 0) return null;
            return (
              <div key={group}>
                <Reveal>
                  <div className="flex items-baseline justify-between mb-4">
                    <h2 className="font-mono text-sm tracking-[0.3em] text-white/50">{group.toUpperCase()}S</h2>
                    <span className="font-mono text-[11px] text-white/30">{String(items.length).padStart(2, "0")}</span>
                  </div>
                </Reveal>
                {items.map((r, i) => (
                  <ReleaseRow key={r.id} release={r} index={i} />
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
